export const findContact = (data, name) => {
  if (!data) return ''
  return data.find((cont) => cont.name === name)?.contact_information ?? ''
}